import { useEffect, useState } from 'react';

import commonSycurioTelephonicEntryService from '../../../services/commonCheckout/commonSycurioTelephonicEntryService';

export default function useStartSycurioTelephonicEntry({
  checkoutSessionId,
  startSpinner,
}: {
  checkoutSessionId: string;
  startSpinner: () => void;
}) {
  const [casiTransactionId, setCasiTransactionId] = useState<
    string | undefined
  >();

  useEffect(() => {
    if (!checkoutSessionId) {
      return;
    }
    (async () => {
      startSpinner();
      try {
        const casiResponse =
          await commonSycurioTelephonicEntryService({
            checkoutSessionId,
            eventType: 'startSycurio',
          });
        setCasiTransactionId(casiResponse?.data?.requestId);
      } catch (e) {
        console.error(
          'Error starting sycurio telephonic entry session',
        );
      }
    })();
  }, [checkoutSessionId]);

  return { casiTransactionId };
}
